import Splide from '@splidejs/splide';

import '@splidejs/splide/css';

import SlideNumber from './components/splide/numbers';
import SlideThumbnails from './components/splide/thumbnails';

/**
 * Carousel sections.
 */
class Carousel {
	/**
	 * Set up a carousel for the given container element and carousel options.
	 *
	 * @param {HTMLElement} container - A DOM element to turn into a carousel.
	 * @param {object} [options] - Carousel options.
	 */
	constructor( container, options = {} ) {
		options.classes = options.classes ?? {};
		options.classes.arrows = `splide__arrows ${ options.classes.arrows ?? '' }`.trim();
		options.classes.arrow = `splide__arrow ${ options.classes.arrow ?? '' }`.trim();
		options.classes.prev = `splide__arrow--prev ${ options.classes.prev ?? '' }`.trim();
		options.classes.next = `splide__arrow--next ${ options.classes.next ?? '' }`.trim();
		options.label = container.dataset.label ?? options.label;
		options.pagination = options.pagination ?? false;

		const {
			showNumbers = container.dataset.showNumbers === 'true',
			showThumbnails = container.dataset.showThumbnails === 'true',
			...carouselOptions
		} = options;

		this.carousel = new Splide( container, carouselOptions );

		const components = {};

		if ( showThumbnails ) {
			components.SlideThumbnails = SlideThumbnails;
		}

		if ( showNumbers ) {
			components.SlideNumber = SlideNumber;
		}

		return this.carousel.mount( components );
	}

	/**
	 * Unmount the carousel.
	 */
	unmount() {
		this.carousel.destroy();
	}
}

window.kaplanBlocks = window.kaplanBlocks ?? {};
window.kaplanBlocks.Carousel = Carousel;
